import RatingProductCard from './RatingProductCard';

export default RatingProductCard;
